import { render, staticRenderFns } from "./SetOrVerifyProfilePin.vue?vue&type=template&id=04647e64&scoped=true&"
import script from "./SetOrVerifyProfilePin.vue?vue&type=script&lang=js&"
export * from "./SetOrVerifyProfilePin.vue?vue&type=script&lang=js&"
import style0 from "./SetOrVerifyProfilePin.vue?vue&type=style&index=0&id=04647e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04647e64",
  null
  
)

export default component.exports